import useEstudianteHomologacionApi from './estudiante/useEstudianteHomologacionApi.js';
import useGestionApi from './gestion/useGestionApi.js';
import useDocenteAsistenciaApi from './docente/useDocenteAsistenciaApi.js';
import useCoordinadorAsistenciaApi from './coordinador/useCoordinadorAsistenciaApi.js';
import useEstudianteCuentaApi from './estudiante/useEstudianteCuentaApi.js';
import useAccesosApi from './accesos/useAccesosApi.js';
import useEstudiantePreconvalidacionApi from './estudiante/useEstudiantePreconvalidacionApi.js';
import useEstudianteNotasApi from './estudiante/useEstudianteNotasApi.js';
import useEstudianteFacturasApi from './estudiante/useEstudianteFacturasApi.js';
import useEjecutivoUsuarioApi from './crm/useEjecutivoUsuarioApi.js';
import useTipoCambioApi from './economico/useTipoCambioApi.js';
import useDeudaApi from './economico/useDeudaApi.js';
import useTransferenciaPagoApi from './economico/useTransferenciaPagoApi.js';
import useBecaApi from './economico/useBecaApi.js';
import usePromedioApi from './academico/usePromedioApi.js';
import usePerfilDocenteApi from './academico/usePerfilDocenteApi.js';
import useRankingEgresadosApi from './academico/useRankingEgresadosApi.js';
import useFactoresCreditoApi from './economico/useFactoresCreditoApi.js';
import useCostosCreditoApi from './economico/useCostosCreditoApi.js';
import useItemsApi from './economico/useItemsApi.js';
import usePlanesEconomicosApi from './economico/usePlanesEconomicosApi.js';
import useOfertaPlanesApi from './economico/useOfertaPlanesApi.js';
import useItemsPlanApi from './economico/useItemsPlanApi.js';
import useReglasCobroApi from './economico/useReglasCobroApi.js';
import useCalendariosPlazosApi from './economico/useCalendariosPlazosApi.js';
import useDisparadoresCobroApi from './economico/useDisparadoresCobroApi.js';
import useConsultaPreciosApi from './economico/useConsultaPreciosApi.js';
import useCongresosApi from './congresos/useCongresosApi.js';
import useEstudianteBusquedaApi from './estudiante/useEstudianteBusquedaApi.js';


const repositories = {
    useEstudianteHomologacionApi,
    useGestionApi,
    useDocenteAsistenciaApi,
    useCoordinadorAsistenciaApi,
    useEstudianteCuentaApi,
    useAccesosApi,
    useEstudiantePreconvalidacionApi,
    useEstudianteNotasApi,
    useEstudianteFacturasApi,
    useEjecutivoUsuarioApi,
    useTipoCambioApi,
    useDeudaApi,
    useTransferenciaPagoApi,
    useBecaApi,
    usePromedioApi,
    usePerfilDocenteApi,
    useRankingEgresadosApi,
    useFactoresCreditoApi,
    useCostosCreditoApi,
    useItemsApi,
    usePlanesEconomicosApi,
    useOfertaPlanesApi,
    useItemsPlanApi,
    useReglasCobroApi,
    useCalendariosPlazosApi,
    useDisparadoresCobroApi,
    useConsultaPreciosApi,
    useCongresosApi,
    useEstudianteBusquedaApi
};

export const apiFactory = (name) => {
    return repositories[name];
}